import { Document, Element, TAGNAME_TEMPLATE, TypeError, isObject, isString, } from "@acng/frontend-bounty/types";
import { adoptNode, append, queryAll } from "@acng/frontend-bounty";
import { UUID_STARGAZER_LOADER } from "../model/resource.js";
import { findOrCreate } from "./find-or-create.js";
/**
 * @param {import("../model/resource.js").ResourceElement} namespace
 * @param {Document | HTMLElement | Object | string} item
 * @param {string[]} path
 * @todo TODO insert HTMLTemplateElement
 * @todo TODO may insert with resource[RESOURCE_COMPILE] = resolved([])
 */
export const insert = (namespace, item, path) => {
    if (item instanceof Document) {
        for (const template of queryAll(TAGNAME_TEMPLATE, item)) {
            const imported = /** @type {import("../model/resource.js").ResourceElement} */ (adoptNode(template));
            append(namespace.content, imported);
        }
    }
    else if (item instanceof Element) {
        const resource = findOrCreate(namespace, ...path);
        append(resource.content, item);
    }
    else if (isObject(item)) {
        createTemplatesFromObject(namespace, item);
    }
    else if (isString(item)) {
        const resource = findOrCreate(namespace, ...path);
        resource.innerHTML = item;
    }
    else {
        throw TypeError(UUID_STARGAZER_LOADER);
    }
};
/**
 * @param {object} translations
 * @param {HTMLTemplateElement} namespace
 */
const createTemplatesFromObject = (namespace, translations) => {
    for (const [key, item] of Object.entries(translations)) {
        const resource = findOrCreate(namespace, key);
        if (isString(item)) {
            append(resource.content, item);
        }
        else {
            createTemplatesFromObject(resource, item);
        }
    }
};
